
<!-- <p>This is the Alert componanet</p> -->
<div [class]="alertService.currentAlert.type" class="window-bar" id="ok-cancel-window-bar">
  <label>{{alertService.currentAlert.title}}</label>
</div>
<div id="customDialogOKCancel" class="AlertContent">
  <label id="dialogMessage">{{alertService.currentAlert.Message}}</label>
  <pre class="stack-trace">{{alertService.currentAlert.error}}</pre>
  @if (alertService.currentAlert.error) {
    <mat-accordion>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-description>
            Show StackTrace
          </mat-panel-description>
        </mat-expansion-panel-header>
        {{alertService.currentAlert.error.error ?? alertService.currentAlert.error}}
      </mat-expansion-panel>
    </mat-accordion>
  }
  <button type="button" id="btnOK" (click)="alertService.currentAlert = null;">OK</button>
</div>

<!--
<p>{{currentAlert.title}}</p>
<p [innerHTML]="currentAlert.Message"></p>
<button mat-flat-button [color]="currentAlert.type" title="OK" (click)="currentAlert = null;" style="margin-left: auto;">OK</button> -->

<!-- <pc-modal *ngIf="currentAlert" (onClose)="currentAlert = null;">
<pc-modal-header title="{{currentAlert.title}}" [type]="currentAlert.type" [iconClass]="icon"></pc-modal-header>
<pc-modal-content>
  <p [innerHTML]="currentAlert.content"></p>
  <mat-accordion *ngIf="currentAlert.StackTrace">
    <mat-expansion-panel
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false">
      <mat-expansion-panel-header>
        <mat-panel-description>
          Show StackTrace
        </mat-panel-description>
      </mat-expansion-panel-header>
      {{currentAlert.StackTrace}}
    </mat-expansion-panel>
  </mat-accordion>
</pc-modal-content>
<pc-modal-buttons>
  <button mat-flat-button [color]="currentAlert.type" title="OK" (click)="currentAlert = null;" style="margin-left: auto;">OK</button>
</pc-modal-buttons>
</pc-modal> -->
